import { Accordion, Box, Text } from '@nimbus-ds/components';
import { CheckCircleIcon } from '@nimbus-ds/icons';
import { IconBox } from 'commons/components';

interface CompletedPromoteGroupItemProps {
  index: number;
  title: string;
}

export function CompletedPromoteGroupItem({
  index,
  title,
}: Readonly<CompletedPromoteGroupItemProps>) {
  return (
    <Accordion.Item index={`${index}`}>
      <Box
        display="flex"
        alignItems="center"
        paddingBottom="2"
        paddingTop="2"
        paddingLeft="4"
        paddingRight="4"
        borderColor={index > 0 ? 'neutral-surfaceHighlight' : undefined}
        borderTopWidth={index > 0 ? '1' : undefined}
        borderStyle={index > 0 ? 'solid' : undefined}
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <IconBox
            backgroundColor="success-surface"
            color="success-textLow"
            borderRadius="2"
            height="28px"
            width="28px"
            marginRight="2"
          >
            <CheckCircleIcon color="currentColor" />
          </IconBox>
        </Box>
        <Text fontWeight="medium" color="neutral-textHigh">
          {title}
        </Text>
      </Box>
    </Accordion.Item>
  );
}
